export default "__VITE_ASSET__DIXyl0Rx__"